import Alpine from "alpinejs";
import { ProductAIS } from "../utilities/AIS/ProductAIS";

document.addEventListener("alpine:init", () => {
    Alpine.data("productAis", (variantId, productId) => new ProductAIS(variantId, productId));
});
